module.exports = __webpack_public_path__ + "img/icon-send.4373266f.svg";